import { render, staticRenderFns } from "./JobContent.vue?vue&type=template&id=1a51a678"
import script from "./JobContent.vue?vue&type=script&lang=js"
export * from "./JobContent.vue?vue&type=script&lang=js"
import style0 from "./JobContent.vue?vue&type=style&index=0&id=1a51a678&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports